import declare from "dojo/_base/declare";
import ActionViewConstructor, { ActionView } from "csi/action/ActionView";
import def from	"csi/def";
import reflection from "csi/reflection";
import AggregateFrom from "csi/table/AggregateFrom";

	
const SelectDSFromPD = declare(AggregateFrom, {

	getActionView(/*ViewRef?*/vr): ActionView {
		const rc = reflection.getClass("DataPackage");
		let defView = def.getClassViewDef(rc, "AggregatePrintDesignDataSheetRevision");
		const ctx = this.getContext();
		const parent = ctx.getParent();
		const style = this.getCache()
			.getNode
			(this.getParent().__Parent__);
		if (style.ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP") {
			defView = def.getClassViewDef(rc, "AggregatePrintDesignDataSheetRevisionWithColorAllocation");
		}
		return new ActionViewConstructor(this, defView, parent);
	},
    
});

export = SelectDSFromPD;